import '#core/application/modules/tiles/event-card-markets-slider/index.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import EVENT_CARD_DETAILS from '#core/application/modules/cards-and-promotions/classic-cards/event-cards/event-card-details.palette-schema.yaml';

import {AvantgardeCards} from '../avantgarde-cards.js';

import {avantgardeVerticalMatchCardsFactory} from './avantgarde-vertical-match-cards.factory.js';

import PALETTE_SCHEMA from './avantgarde-vertical-match-cards.palette-schema.yaml';

registerTileSchema(EVENT_CARD_DETAILS);

class AvantgardeVerticalMatchCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'AvantgardeVerticalMatchCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return avantgardeVerticalMatchCardsFactory(PALETTE);
    }
}

new AvantgardeVerticalMatchCardsFeature(AvantgardeCards);
